import { Model } from "../../types/models";

export const sortedModelsByWeeklyScores = (models: Model[]) => {
  return models.sort((a, b) => {
    if (!a.weeklyScores) return 1;
    if (!b.weeklyScores) return -1;

    return b.weeklyScores.current_week_avg_visibility - a.weeklyScores.current_week_avg_visibility;
  });
};